// extracted by mini-css-extract-plugin
export default {"deposit":"Deposit_deposit__rC5iP","input":"Deposit_input__mo6nf","inputNew":"Deposit_inputNew__H-HQ9","newDeposit":"Deposit_newDeposit__Lcqnc","text":"Deposit_text__XzvtX"};